export const BRIDGE_KEYS = {
  GLOBAL: 'global',
  DEALER: 'dealer',
  EDIT: 'edit',
  FOCUS_EMAIL: 'focus-email',
  DISCARD: 'discard',
  NICKNAME: 'nickname',
  REMOVE_VEHICLE: 'remove-vehicle',
  RESET_PIN: 'reset-pin',
} as const;

export class LayerDataBridge<T = unknown> {
  private static instances = new Map<string, LayerDataBridge<any>>();
  private listeners: Set<(data: T | null) => void> = new Set();
  private data: T | null = null;

  static getInstance<T>(key: string): LayerDataBridge<T> {
    if (!LayerDataBridge.instances.has(key)) {
      LayerDataBridge.instances.set(key, new LayerDataBridge<T>());
    }
    return LayerDataBridge.instances.get(key) as LayerDataBridge<T>;
  }

  setData(data: T | null): void {
    this.data = data;
    this.listeners.forEach((l) => l(data));
  }

  getData(): T | null {
    return this.data;
  }

  subscribe(listener: (data: T | null) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
